import { getLocalDataIfNotExpired } from '@services/storage';

import { LmPartners } from '@app-types/eligibility';

import { ELIGIBILITY_STORAGE_KEY } from '@constants/provider';

const ACCESS_KEY_MAX_AGE_MS = 10 * 60 * 1000;

// key is a timestamp checked to ensure it was generated recently
export function isAccessKeyValid(key: string): boolean {
    const timestamp = Number(key);
    if (Number.isNaN(timestamp)) return false;
    const age = Date.now() - timestamp;
    return age >= 0 && age <= ACCESS_KEY_MAX_AGE_MS;
}

export function getAccessKeyPartner(
    key: string | null,
    partnerValue: string | null,
    lmPartners: LmPartners,
): LmPartners[number] | null {
    if (!key || !partnerValue || !isAccessKeyValid(key)) return null;
    return lmPartners.find((p) => p.value === partnerValue) ?? null;
}

export function isReferrerValid(referrers: string[]): boolean {
    const domain = getReferrerDomain();
    const isFromCheckout = document.referrer.startsWith(`${document.location.origin}/panier`);
    return !(
        (referrers && !domain) ||
        (referrers && domain && !(referrers.some((r) => domain.includes(r)) || isFromCheckout))
    );
}

export function getReferrerDomain(): string | null {
    const referrer = document.referrer || getLocalDataIfNotExpired<string | null>(ELIGIBILITY_STORAGE_KEY.LM_PARTNER);
    const url = referrer ? new URL(referrer) : null;
    return url?.hostname || null;
}
